import classNames from 'classnames';
import Component from './Component';
import immutable from 'immutable';
import React from 'react';
import uuid from 'uuid';
import {ProgressBar} from 'react-bootstrap';
import ImagePaste from '../../components/ImagePaste';
import ReactDOM from 'react-dom';

(function($) {
	var defaults;
	$.event.fix = (function(originalFix) {
		return function(event) {
			event = originalFix.apply(this, arguments);
			if (event.type.indexOf('copy') === 0 || event.type.indexOf('paste') === 0) {
				event.clipboardData = event.originalEvent.clipboardData;
			}
			return event;
		};
	})($.event.fix);
	defaults = {
		callback: $.noop,
		matchType: /image.*/
	};
	return $.fn.pasteImageReader = function(options) {
		if (typeof options === "function") {
			options = {
				callback: options
			};
		}
		options = $.extend({}, defaults, options);
		return this.each(function() {
			var $this, element;
			element = this;
			$this = $(this);
			return $this.bind('paste', function(event) {
				var clipboardData, found;
				found = false;
				clipboardData = event.clipboardData;
				return Array.prototype.forEach.call(clipboardData.types, function(type, i) {
					var file, reader;
					if (found) {
						return;
					}
					if (type.match(options.matchType) || clipboardData.items[i].type.match(options.matchType)) {
						file = clipboardData.items[i].getAsFile();
						reader = new FileReader();
						reader.onload = function(evt) {
							return options.callback.call(element, {
								dataURL: evt.target.result,
								event: evt,
								file: file,
								name: file.name
							});
						};
						reader.readAsDataURL(file);
						//snapshoot();
						return found = true;
					}
				});
			});
		});
	};
})(window.jQuery);

class FileUpload extends Component {

	static defaultProps = {
		multiSelection: true,
	};

	constructor(props) {
		super(props);
		this.uid = uuid.v4();
		this.state = {
			busy: false,
			overed: false,
			files: [],
			value: props.value ? props.value.toJS() : []
		}
	}


	componentWillReceiveProps(nextProps) {
		this.setState({value: nextProps.value ? nextProps.value.toJS() : []});
	}

	componentDidMount() {
		this.uploader = new plupload.Uploader({
			runtimes : 'html5,html4',
			multi_selection: this.props.multiSelection,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button : this.uid + '_pickfiles',
			url : '/upload/file',
			filters : {
				max_file_size : '500mb'
			},
			init: {
				FilesAdded: (up, files) => {
					plupload.each(files, (file) => {
						this.handleFileAdd(file);
					});
					this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function(up, err) {
					alert(err.message);
				}
			}
		});
		this.uploader.init();

		$(ReactDOM.findDOMNode(this.refs.dropzone)).pasteImageReader((results) => {
			 const file = {status: 1, id: -Math.random(), name: 'screenshot.png'};
			window.jQuery.ajax({
				type: "POST",
				url: '/upload/paste',
				data: {
					title: 'screenshot.png',
					data: results.dataURL
				},
				success: (response) => {
					file.status = plupload.DONE;
					this.handleFileUploaded(null, file, response, false);
					this.changedValue();
				},
				dataType: 'json'
			});
			this.handleFileAdd(file);
		});
	}

	componentWillUnmount() {
		this.uploader.destroy();
	}

	startUpload() {
		if (!this.props.multiSelection) {
			this.setState({value: [], files: []});
		}
		this.setState({busy: true});
		this.uploader.start();
	}

	handleFileAdd(file) {
		if (this.props.multiSelection) {
			this.state.files.push(file);
		}
		else {
			this.state.files = [file];
		}
		this.forceUpdate();
	}

	handleUploadProgress(up, file) {
		this.forceUpdate();
	}

	handleFileUploaded(up, file, response, jsonDecode = true) {
		if (jsonDecode) {
			response = JSON.parse(response.response);
		}
		const o = {
			title:file.name,
			url: '/file/download-tmp/?file='+response.file + '&name=' + encodeURIComponent(file.name),
			preview: response.preview,
			file: response.file,
			id: -Math.random()
		};
		if (this.props.multiSelection) {
			this.state.value.push(o);
		}
		else {
			this.state.value = [o];
		}
		this.forceUpdate();
		//this.setState({value: this.state.value});
	}

	handleUploadComplete(up, files) {
		this.setState({files:[], busy: false});
		this.changedValue();
	}

	handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	}

	changedValue() {
		const value = immutable.fromJS(this.state.value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	handleDelete(id) {
		this.state.value = this.state.value.filter((file) => file.id != id);
		this.changedValue();
	}

	dragEnter(e){
		this.setState({overed:true});
	}

	dragLeave(e){
		this.setState({overed:false});
	}

	handleFocusDropzone() {
	}

	renderInput() {

		const files = this.state.files.filter(file => file.status != plupload.DONE).map(file => {

				return <tr key={file.id}>
							<td>
								<div style={{marginBottom: 2}}>
									<div style={{float:'left', width: 45}}>
										&nbsp;
									</div>
									<div style={{float:'left'}}>
										{file.name}
									</div>
									<div style={{clear: 'both'}}></div>
								</div>

							</td>
							<td>
								<span className="fa fa-circle-o-notch spinner" />
								{file.size > 1000000 && <span> {file.percent}%</span>}
							</td>
						</tr>
		});
		const value = this.state.value.map(file => {
			let ico = 'fa fa-file-text-o'
			let color = '';
			if (file.type == 'pdf') {
				ico = 'fa fa-file-pdf-o';
				color = '#A00';
			}
			if (file.type == 'xls' || file.type == 'xlsx') {
				ico = 'fa fa-file-excel-o';
				color = '#080';
			}
			if (file.type == 'doc' || file.type == 'docx') {
				ico = 'fa fa-file-word-o';
				color = '#007';
			}

			return <tr key={file.id}>
						<td>
							<div style={{marginBottom: 2}}>
								<div style={{float:'left', width: 45, textAlign: 'center'}}>
									<a href={file.url}>
										{file.preview &&
										<img style={{border: '1px solid #777'}} src={file.preview.url}/>
										}
										{!file.preview &&
											<span style={{color: color}} className={ico}></span>
										}
									</a>&nbsp;
								</div>
								<div style={{float:'left'}}>
									<a href={file.url}>
										{file.title}
									</a>
									&nbsp;
								</div>
								<div style={{clear: 'both'}}></div>
							</div>
						</td>
						<td onClick={(e) => this.handleDelete(file.id)} style={{cursor:'pointer'}}>
							<span className="icon-cross3" />
						</td>
					</tr>
		});

		return <div  id={this.uid + '_dropzone'}>
				<table onClick={this.handleClick} className="fileupload">
					<tbody>
						<tr>
							<td colSpan="2">
								<table style={{width:'100%', marginBottom: 5}}>
									<tbody>
										{value}
										{files}
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<td>
								<div id={this.uid + '_pickfiles'}  ref="dropzone" onClick={() => this.handleFocusDropzone()} tabIndex="0" className={classNames('dropzone', {'overed': this.state.overed})}
									 onDragEnter={this.dragEnter.bind(this)}
									 onDrop={this.dragLeave.bind(this)}
									 onDragLeave={this.dragLeave.bind(this)}>
									<span className="fa fa-folder-open-o position-left"></span>
									{this.props.dropText ? this.props.dropText : (this.props.multiSelection ? 'Klikněte pro výběr z disku nebo přetáhněte soubory sem' : 'Klikněte pro výběr z disku nebo přetáhněte soubor sem')}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

	}

	renderError() {
		return this.props.error ? (
			React.createElement("span", {className: "error-block", key: "error"},
				this.props.error
			)
		) : null;
	}

	renderWrapper(children) {
		return this.props.wrapperClassName ? (
			React.createElement("div", {className: this.props.wrapperClassName, key: "wrapper"},
				children
			)
		) : children;
	}

	renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return (
			React.createElement("div", {className: classNames(classes)},
				children
			)
		);
	}

	render() {
		return this.renderFormGroup([
			this.renderWrapper([
				this.renderInput()
			]),
			this.renderError()
		]);
	}
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/FileUpload.js